import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the app router, we can initialize the `}<inlineCode parentName="p">{`posthog-node`}</inlineCode>{` SDK once with a `}<inlineCode parentName="p">{`PostHogClient`}</inlineCode>{` function, and import it into files.`}</p>
    <p>{`This enables us to send events and fetch data from PostHog on the server – without making client-side requests.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// app/posthog.js
import { PostHog } from 'posthog-node'

export default function PostHogClient() {
  const posthogClient = new PostHog(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    flushAt: 1,
    flushInterval: 0
  })
  return posthogClient
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Because server-side functions in Next.js can be short-lived, we set `}<inlineCode parentName="p">{`flushAt`}</inlineCode>{` to `}<inlineCode parentName="p">{`1`}</inlineCode>{` and `}<inlineCode parentName="p">{`flushInterval`}</inlineCode>{` to `}<inlineCode parentName="p">{`0`}</inlineCode>{`. `}</p>
      <ul parentName="blockquote">
        <li parentName="ul"><inlineCode parentName="li">{`flushAt`}</inlineCode>{` sets how many capture calls we should flush the queue (in one batch). `}</li>
        <li parentName="ul"><inlineCode parentName="li">{`flushInterval`}</inlineCode>{` sets how many milliseconds we should wait before flushing the queue.
Setting them to the lowest number ensures events are sent immediately and not batched. We also need to call `}<inlineCode parentName="li">{`await posthog.shutdown()`}</inlineCode>{` once done.`}</li>
      </ul>
    </blockquote>
    <p>{`To use this client, we import it into our pages and call it with the `}<inlineCode parentName="p">{`PostHogClient`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import Link from 'next/link'
import PostHogClient from '../posthog'

export default async function About() {

  const posthog = PostHogClient()
  const flags = await posthog.getAllFlags(
    'user_distinct_id' // replace with a user's distinct ID
  );
  await posthog.shutdown()

  return (
    <main>
      <h1>About</h1>
      <Link href="/">Go home</Link>
      { flags['main-cta'] &&
        <Link href="http://posthog.com/">Go to PostHog</Link>
      }
    </main>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      